// extracted by mini-css-extract-plugin
export default {"detailPanel":"ActionCenter_detailPanel__6k7nH","text-muted":"ActionCenter_text-muted__43q+4","chip":"ActionCenter_chip__aRV2w"};